import * as Dropdown from 'components/dropdown'
import * as Elasticsearch from 'services/elasticsearch'

import * as Constants from './constants'

export interface OpenClickPoint {
  timestamp: string,
  totalClick: number,
  totalClickRate: number,
  totalDelivered: number,
  totalOpen: number,
  totalOpenRate: number,
  uniqueClick: number,
  uniqueClickRate: number,
  uniqueDelivered: number,
  uniqueOpen: number,
  uniqueOpenRate: number,
}

export const DisplayOptionTypes = {
  TotalCounts: 'TotalCounts',
  TotalRates: 'TotalRates',
  UniqueCounts: 'UniqueCounts',
  UniqueRates: 'UniqueRates'
}

export const DisplayOptions: Dropdown.DropdownOption[] = [
  {key: 1, value: DisplayOptionTypes.TotalCounts, description: 'Total Counts'},
  {key: 2, value: DisplayOptionTypes.TotalRates, description: 'Total %'},
  {key: 3, value: DisplayOptionTypes.UniqueCounts, description: 'Unique Counts'},
  {key: 4, value: DisplayOptionTypes.UniqueRates, description: 'Unique %'},
]

export const SuspectOptionTypes = {
  All: 'All',
  Real: 'Real',
}

export const SuspectOptions: Dropdown.DropdownOption[] = [
  {key: 1, value: SuspectOptionTypes.Real, description: 'Valid Activity'},
  {key: 2, value: SuspectOptionTypes.All, description: 'All Activity'},
]

export interface ViewState {
  selectedDateRange: Dropdown.DropdownOption,
  selectedDisplay: Dropdown.DropdownOption,
  selectedInterval: Dropdown.DropdownOption,
  selectedSuspect: Dropdown.DropdownOption,
}

export const emptyState: ViewState = {
  selectedDateRange: Constants.dateRangeDropdownOption(Elasticsearch.DateRanges.LastMonth),
  selectedDisplay: Dropdown.dropdownOption(DisplayOptionTypes.UniqueRates, DisplayOptions),
  selectedInterval: Elasticsearch.intervalDropdownOption(Elasticsearch.AggregationIntervals.Week),
  selectedSuspect: Dropdown.dropdownOption(SuspectOptionTypes.All, SuspectOptions),
}

export const DisplayType = {
  All: 'all',
  Chart: 'chart',
  Table: 'table'
}